import { http, HttpResponse } from 'msw';

const handlers = [
  http.get('/api/regions', () => {
    return HttpResponse.json({});
  }),
];

export default handlers;
